module.exports = __webpack_public_path__ + "img/default.ee854f29.svg";